import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import {
  PATH_HOME,
  PATH_MONITORAGGIO,
  PATH_COOKIE_POLICY,
  PATH_PRIVACY_POLICY,
  PATH_COLORI_TRIAGE,
  PATH_FAQ,
  PATH_INFO,
  PATH_CONTATTI,
} from "../path";
import { Footer, Header, CodiciColore, Contatti, Cookie, Faq, Home, Info, Monitoraggio, PageNotFound, Privacy } from "../components";

export const SwitchContent = () => {
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Box sx={{ height: "100%" }}>
      <Header />
      <Routes>
        <Route path={PATH_HOME} element={<Home />} />
        <Route path={PATH_MONITORAGGIO} element={<Monitoraggio />} />
        <Route path={PATH_INFO} element={<Info />} />
        <Route path={PATH_PRIVACY_POLICY} element={<Privacy />} />
        <Route path={PATH_COOKIE_POLICY} element={<Cookie />} />
        <Route path={PATH_COLORI_TRIAGE} element={<CodiciColore />} />
        <Route path={PATH_FAQ} element={<Faq />} />
        <Route path={PATH_CONTATTI} element={<Contatti />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      {window.ReactNativeWebView == null && <Footer />}
    </Box>
  );
};
